export class AppointmentConfirm
{
    public token: string;
    public confirm: boolean;
}
